import { ServiceSegmentSubType } from '@mewa/types';
import {
  ProtectiveClothingBoxIcon,
  ProtectiveClothingChemicalsIcon,
  ProtectiveClothingFireIcon,
  ProtectiveClothingGlassIcon,
  ProtectiveClothingHotFlourIcon,
  ProtectiveClothingLiquidMetalIcon,
  ProtectiveClothingReflectiveVestIcon,
  ProtectiveClothingWeatherIcon,
} from '@mewa/ui';

export const protectiveClothingIconForType = (
  typeName: string,
): React.ReactElement => {
  switch (typeName as ServiceSegmentSubType) {
    case ServiceSegmentSubType.chemicalProtection:
      return <ProtectiveClothingChemicalsIcon />;
    case ServiceSegmentSubType.productProtection:
      return <ProtectiveClothingBoxIcon />;
    case ServiceSegmentSubType.foundryProtection:
      return <ProtectiveClothingLiquidMetalIcon />;
    case ServiceSegmentSubType.glassProtection:
      return <ProtectiveClothingGlassIcon />;
    case ServiceSegmentSubType.heatAndFlameProtection:
      return <ProtectiveClothingFireIcon />;
    case ServiceSegmentSubType.hiVisProtection:
      return <ProtectiveClothingReflectiveVestIcon />;
    case ServiceSegmentSubType.weatherProtection:
      return <ProtectiveClothingWeatherIcon />;
    case ServiceSegmentSubType.cementProtection:
      return <ProtectiveClothingHotFlourIcon />;

    default:
      return <span />;
  }
};
